import React, {useEffect, useState} from 'react';
import {
  Form, Input, Button,
  Row, Col, Typography,
  message, DatePicker,
} from "antd";
import {LeftOutlined, SaveOutlined} from "@ant-design/icons";
import {useHistory} from 'react-router-dom';
import {addDoc, collection, doc, getDoc, updateDoc} from "firebase/firestore";
import {firestore} from "../../services/firebase";
import {useQuery} from "../../hooks";
import AppLoading from '../../components/AppLoading';
import moment from 'moment';
import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES';


const FormVideo = () => {

  const history = useHistory();
  const query = useQuery();
  const {Title} = Typography;
  const [form] = Form.useForm();
  const [video, setVideo] = useState([]);
  const [loading, setLoading] = useState(true);


  const id = query.get("id");
  const editing = !!id;

  const onFinish = async (values) => {
    try {
      if (editing) {
        const res = await updateDoc(doc(firestore, "videos", id), {
          autor: values.autor,
          descripcion: values.descripcion,
          horario: values.horario.toDate(),
          nombre: values.nombre,
          url: values.url,
        });
        !res ? message.success('Cambios guardados.') : message.error('Error al actualizar.');
      } else {
        const res = await addDoc(collection(firestore, "videos"), {
          ...values,
          estatus: 1,
          horario: values.horario.toDate(),
          fecha_alta: new Date()
        });
        //Agregar doc en visitas
        const res2 = await addDoc(collection(firestore, "contador"), {idVideo: res.id,});
        res && res2 ? message.success('Video agregado.') : message.error('Error al guardar.');
      }
    } catch (error) {
      message.error('Error al guardar.');
      console.log(error)
    }
    history.goBack();
  };

  const onFinishFailed = (onFinishFailed) => {
    console.log("Failed: ", onFinishFailed);
  }


  useEffect(() => {
    let mounted = true;

    if (mounted && editing) {
      setTimeout(async () => {
        const docRef = doc(firestore, "videos", id);
        const docSnap = await getDoc(docRef);
        setLoading(false);
        setVideo(docSnap.data());
      }, 0)

    }
    return () => {
      mounted = false
    };
  }, [loading, form, id, editing]);

  useEffect(() => {
    if (!loading && video && video.horario) {
      let fecha = moment(video.horario.toDate())
      form.setFieldsValue({
        ...video,
        horario: fecha,
      })
    }
  }, [video, loading, form]);


  if (loading && editing) {
    return <AppLoading/>
  }

  return (
    <>
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 13, offset: 0}}
          md={{span: 12, offset: 0}}
          lg={{span: 12, offset: 0}}
          xxl={{span: 12, offset: 0}}
        >
          <Title level={4}>{editing ? 'Editar' : 'Agregar'} video</Title>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 7, offset: 4}}
          md={{span: 5, offset: 7}}
          lg={{span: 4, offset: 8}}
          xxl={{span: 3, offset: 9}}
        >

          <Button
            type='primary'
            block
            size="large"
            icon={<LeftOutlined/>}
            onClick={() => history.goBack()}
          >Volver
          </Button>
        </Col>
      </Row>

      <Form
        style={{marginTop: 20}}
        name="form"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="Nombre"
              name="nombre"
              rules={[{required: true, message: "Requerido"}]}>
              <Input
                autoComplete="off"
                size="large"/>
            </Form.Item>
          </Col>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="URL"
              name="url"
              rules={[{required: true, message: "Requerido"}]}>
              <Input
                autoComplete="off"
                size="large"/>
            </Form.Item>
          </Col>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="Nivel"
              name="index"
              rules={[{required: true, message: "Requerido"}]}>
              <Input
                autoComplete="off"
                size="large"/>
            </Form.Item>
          </Col>

        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="Horario"
              name="horario"
              rules={[{required: true, message: "Requerido"}]}
            >
              <DatePicker
                locale={locale}
                style={{width: '100%'}}
                size="large"
                showTime
                format="DD-MM-YYYY HH:mm"
              />
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="Año"
              name="anio"
              rules={[{required: true, message: "Requerido"}]}>
              <Input
                autoComplete="off"
                size="large"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 8, offset: 0}}
            xxl={{span: 8, offset: 0}}
          >
            <Form.Item
              label="Autor"
              name="autor"
              rules={[{required: true, message: "Requerido"}]}>
              <Input
                autoComplete="off"
                size="large"/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 24, offset: 0}}
            lg={{span: 24, offset: 0}}
            xxl={{span: 24, offset: 0}}
          >
            <Form.Item
              label="Descripción"
              name="descripcion"
              rules={[{required: true, message: "Requerido",}]}
            >
              <Input.TextArea rows="8" autoComplete="off"/>
            </Form.Item>
          </Col>

        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 8, offset: 16}}
            md={{span: 6, offset: 18}}
            lg={{span: 4, offset: 20}}
            xxl={{span: 4, offset: 20}}
          >
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined/>}
              block
              size="large">
              Guardar
            </Button>
          </Col>
        </Row>

      </Form>
    </>
  )
}

export default FormVideo
